import $ from 'jquery';

const staticDuration = 8000;
const fadeDuration = 2000;

function resizeHeader() {
    let distanceToTop = $(window).scrollTop();
    if (distanceToTop > 0) {
        $('.header').addClass('flatter');
    } else {
        $('.header').removeClass('flatter');
    }
}

function animateLogo() {
    $('.header__logo.mmm')
        .delay(staticDuration)
        .fadeOut(fadeDuration, function () {
            $('.header__logo.nbs').fadeIn(fadeDuration, function () {
                $('.header__logo.nbs')
                    .delay(staticDuration)
                    .fadeOut(fadeDuration, function () {
                        $('.header__logo.mmm').fadeIn(fadeDuration, animateLogo);
                    });
            });
        });
}

$(function () {
    resizeHeader();
    animateLogo();
    $(window).on('scroll', resizeHeader);
});
